import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Platform, ScrollView, View } from 'react-native';
import RenderHtml from 'react-native-render-html';
import PropTypes from 'prop-types';
import AppContext from '../../contexts/App';
import AuthContext from '../../contexts/Auth';
import useAxios from '../../hooks/useAxios';
import Loading from './Loading';
import { H4 } from '../text';

const UserProfile = ({ width }) => {
    const { postGeneric } = useAxios();
    const {
        state: {
            settings: { openIdSettings }
        }
    } = useContext(AppContext);
    const {
        state: { user }
    } = useContext(AuthContext);
    const [constituentAccountHTML, setConstituentAccountHTML] = useState();
    const [error, setError] = useState();

    const getConstituentAccountHTML = useCallback(async () => {
        if (user && user.loggedIn && user.tid) {
            const endpoint = `${openIdSettings.authority}/ConstituentAccount/Cornerstone?tid=${user.tid}`;
            const response = await postGeneric(endpoint, undefined, undefined, {
                Authorization: `Bearer ${user.accessToken}`
            });

            if (response) {
                setConstituentAccountHTML(response);
            } else {
                setError(true);
            }
        }
    }, [openIdSettings, postGeneric, user]);

    useEffect(() => {
        (async () => await getConstituentAccountHTML())();
    }, []);

    if (!user || !user.loggedIn || !user.tid) {
        if (Platform.OS.equals('web')) {
            window.location = '/';
        }

        return;
    }

    if (!constituentAccountHTML && !error) {
        return (
            <View style={{ alignContent: 'center', height: '100%', width }}>
                <Loading />
            </View>
        );
    } else if (!constituentAccountHTML && error) {
        return (
            <View style={{ alignItems: 'center', flexDirection: 'row', justifyContent: 'center', margin: Platform.OS.equals('web') ? '30pt' : 30 }}>
                <H4 style={{ color: '#a61a2b' }} text='Error encountered retrieving your profile. Please try again.' />
            </View>
        );
    }

    if (Platform.OS.equals('web')) {
        return (
            <View style={{ marginBottom: 40 }}>
                <iframe
                    frameBorder='0'
                    seamless='seamless'
                    srcDoc={constituentAccountHTML}
                    style={{ height: window.innerHeight - 80, width: width }}
                />
            </View>
        );
    } else {
        return (
            <ScrollView showsVerticalScrollIndicator={false} width={width}>
                <RenderHtml
                    contentWidth={width}
                    defaultTextProps={{ selectable: true }}
                    emSize={16}
                    enableCSSInlineProcessing={true}
                    enableExperimentalMarginCollapsing={true}
                    enableExperimentalBRCollapsing={false}
                    enableExperimentalGhostLinesPrevention={false}
                    source={{
                        html: constituentAccountHTML,
                        baseUrl: openIdSettings.authority
                    }}
                />
            </ScrollView>
        );
    }
};

UserProfile.propTypes = {
    width: PropTypes.number
};

export default UserProfile;
